import Vue from 'vue'
import VueRouter from 'vue-router'
//通过Vue.use安装
Vue.use(VueRouter)

//引入组件
import logon from '../pages/logon'
import index from '../pages/index'
import forget from '../pages/forget'
import wait_for from '../pages/wait_for'
//趣学习
import study from '../pages/study/study'
import practice from '../pages/study/practice'
import practice_list from '../pages/study/practice_list'
import practice_test from '../pages/study/practice_test'
import famous from '../pages/study/famous'
import famous_download from '../pages/study/famous_download'
import test_index from '../pages/study/test_index'
import test_list from '../pages/study/test_list'
import video from '../pages/study/video'
import video_search from '../pages/study/video_search'
import my_course from '../pages/study/my_course'
import special from '../pages/study/special'
import special_details from '../pages/study/special_details'
import report from '../pages/study/report'
import wrong from '../pages/study/wrong'
import subject from '../pages/study/subject'
import teacher from '../pages/study/teacher'
//生涯宝库
import career from '../pages/career/career'
import career_details from '../pages/career/career_details'
import career_test from '../pages/career/career_test'
import career_report from '../pages/career/career_report'
import choice from '../pages/career/choice'
import choice_collect from '../pages/career/choice_collect'
import choice_subject from '../pages/career/choice_subject'
import choice_intenticon from '../pages/career/choice_intention'
import choice_major from '../pages/career/choice_major'
import contrast from '../pages/career/contrast'
import treasury from '../pages/career/treasury'
import treasury_major from '../pages/career/treasury_major'
import treasury_details from '../pages/career/treasury_details'
import treasury_career from '../pages/career/treasury_career'
import treasury_un from '../pages/career/treasury_un'
//高中资讯
import news_list from '../pages/news/news_list'
import news_details from '../pages/news/news_details'
//会员
import vip_code from '../pages/vip_code'
import vip_buy from '../pages/vip_buy'
//个人中心
import personal from '../pages/personal/personal'
import personal_protect from '../pages/personal/personal_protect'
import payment from '../pages/personal/payment'
import order from '../pages/personal/order'
import phone from '../pages/personal/phone'
import password from '../pages/personal/password'
//志愿填报
import wish from '../pages/wish/wish'
import wish_list from '../pages/wish/wish_list'
//帮助中心
import help from '../pages/help/help'
import help_list from '../pages/help/help_list'
import help_details from '../pages/help/help_details'
//学生端
import my_task from '../pages/student/my_task'
import my_task_list from '../pages/student/my_task_list'
import add_class from '../pages/student/add_class'
import my_class from '../pages/student/my_class'
import my_info from '../pages/student/my_info'
import task_school_paper from '../pages/student/task_school_paper'
import task_report from '../pages/student/task_report'
import task_proof from '../pages/student/task_proof'
import task_school_report from '../pages/student/task_school_report'
//教师端
import class_manage from '../pages/teacher/class_manage'
import class_details from '../pages/teacher/class_details'
import class_join from '../pages/teacher/class_join'
import task from '../pages/teacher/task'
import task_video from '../pages/teacher/task_video'
import task_paper from '../pages/teacher/task_paper'
import task_topic from '../pages/teacher/task_topic'
import school_paper from '../pages/teacher/school_paper'
import school_video from '../pages/teacher/school_video'
import record from '../pages/teacher/record'
import organize from '../pages/teacher/organize'
import organize_details from '../pages/teacher/organize_details'
import basket from '../pages/teacher/basket'
import basket_success from '../pages/teacher/basket_success'
import paper_details from '../pages/teacher/paper_details'
import alipay from '../pages/alipay.vue'
import paper_my from '../pages/teacher/paper_my'
import courseware_upload from '../pages/teacher/courseware_upload'

import courseware from '../pages/teacher/courseware'

import paper_found from '../pages/teacher/paper_found'
import paper_edit from '../pages/teacher/paper_edit'
import video_my from '../pages/teacher/video_my'
import video_upload from '../pages/teacher/video_upload'
import video_play from '../pages/teacher/video_play'
import student_report from '../pages/teacher/student_report'
import kno_report from '../pages/teacher/kno_report'
import notice from '../pages/teacher/notice'
import record_details from '../pages/teacher/record_details'
import agreement from '../pages/agreement'

//创建路由对象
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: '首页',
			component: index,
			meta: {title: "趣学云课堂"},
		},{
			path: '/logon',
			name: "注册",
			component: logon,
			meta: {title: "注册"},
		},{
			path: '/agreement',
			name: "Agreement",
			component: agreement,
			meta: {title: "用户注册协议"},
		},{
			path: '/forget',
			name: "忘记密码",
			component: forget,
			meta: {title: "忘记密码"},
		},{
			path: '/wait_for',
			name: "正在跳转",
			component: wait_for,
			meta: {title: "正在跳转"},
		},{
			path: '/alipay',
			name: "支付宝跳转",
			component: alipay,
			meta: {title: "支付宝跳转"},
		},{
			path: '/news_list',
			name: "高中资讯",
			component: news_list,
			meta: {title: "高中资讯"},
		},{
			path: '/news_details',
			name: "高中资讯详情",
			component: news_details,
			meta: {title: "资讯详情"},
		},{
			path: '/study',
			name: "趣学习",
			component: study,
			meta: {title: "趣学习"},
		},{
			path: '/practice',
			name: "练习",
			component: practice,
			meta: {title: "练习"},
		},{
			path: '/practice_list',
			name: "练习列表",
			component: practice_list,
			meta: {title: "练习列表"},
		},{
			path: '/practice_test',
			name: "练习做试题",
			component: practice_test,
			meta: {title: "练习做试题"},
		},{
			path: '/famous',
			name: "名校试卷",
			component: famous,
			meta: {title: "名校试卷"},
		},{
			path: '/famous_download',
			name: "名校试卷下载",
			component: famous_download,
			meta: {title: "名校试卷下载"},
		},{
			path: '/test_index',
			name: "试卷",
			component: test_index,
			meta: {title: "试卷"},
		},{
			path: '/test_list',
			name: "试卷列表",
			component: test_list,
			meta: {title: "试卷列表"},
		},{
			path: '/report',
			name: "试卷报告",
			component: report,
			meta: {title: "试卷报告"},
		},{
			path: '/wrong',
			name: "错题本",
			component: wrong,
			meta: {title: "错题本"},
		},{
			path: '/video',
			name: "视频",
			component: video,
			meta: {title: "视频"},
		},{
			path: '/video_search',
			name: "视频搜索",
			component: video_search,
			meta: {title: "视频搜索"},
		},{
			path: '/my_course',
			name: "我的课程",
			component: my_course,
			meta: {title: "我的课程"},
		},{
			path: '/special',
			name: "学习专题",
			component: special,
			meta: {title: "学习专题"},
		},{
			path: '/special_details',
			name: "学习专题详情",
			component: special_details,
			meta: {title: "学习专题详情"},
		},{
			path: '/subject',
			name: "学科分类",
			component: subject,
			meta: {title: "学科分类"},
		},{
			path: '/teacher',
			name: "教师详情",
			component: teacher,
			meta: {title: "教师详情"},
		},{
			path: '/career',
			name: "生涯规划",
			component: career,
			meta: {title: "生涯规划"},
		},{
			path: '/career_details',
			name: "测试试题",
			component: career_details,
			meta: {title: "试题"},
		},{
			path: '/career_test',
			name: "测试详情",
			component: career_test,
			meta: {title: "测试详情"},
		},{
			path: '/career_report',
			name: "测试报告",
			component: career_report,
			meta: {title: "测试报告"},
		},{
			path: '/choice',
			name: "3+2+1选科",
			component: choice,
			meta: {title: "3+2+1选科"},
		},{
			path: '/choice_collect',
			name: "我收藏的组合",
			component: choice_collect,
			meta: {title: "我收藏的组合"},
		},{
			path: '/choice_subject',
			name: "选科查询系统-按科目组合",
			component: choice_subject,
			meta: {title: "选科查询系统-按科目组合"},
		},{
			path: '/choice_intention',
			name: "选科查询系统-按意向志愿",
			component: choice_intenticon,
			meta: {title: "选科查询系统-按意向志愿"},
		},{
			path: '/choice_major',
			name: "选科查询系统-按专业名称",
			component: choice_major,
			meta: {title: "选科查询系统-按专业名称"},
		},{
			path: '/contrast',
			name: "科目对比分析",
			component: contrast,
			meta: {title: "科目对比分析"},
		},{
			path: '/treasury',
			name: "生涯宝库",
			component: treasury,
			meta: {title: "生涯宝库"},
		},{
			path: '/treasury_major',
			name: "专业信息库",
			component: treasury_major,
			meta: {title: "专业信息库"},
		},{
			path: '/treasury_details',
			name: "专业信息详情",
			component: treasury_details,
			meta: {title: "信息详情"},
		},{
			path: '/treasury_career',
			name: "职业信息库",
			component: treasury_career,
			meta: {title: "职业信息库"},
		},{
			path: '/treasury_un',
			name: "院校信息库",
			component: treasury_un,
			meta: {title: "院校信息库"},
		},{
			path: '/vip_code',
			name: "激活会员",
			component: vip_code,
			meta: {title: "激活会员"},
		},{
			path: '/vip_buy',
			name: "在线购卡",
			component: vip_buy,
			meta: {title: "在线购卡"},
		},{
			path: '/personal',
			name: "基础资料",
			component: personal,
			meta: {title: "基础资料"},
		},{
			path: '/personal_protect',
			name: "账号保护",
			component: personal_protect,
			meta: {title: "账号保护"},
		},{
			path: '/payment',
			name: "充值中心",
			component: payment,
			meta: {title: "充值中心"},
		},{
			path: '/order',
			name: "我的订单",
			component: order,
			meta: {title: "我的订单"},
		},{
			path: '/phone',
			name: "更换手机",
			component: phone,
			meta: {title: "更换手机"},
		},{
			path: '/password',
			name: "修改密码",
			component: password,
			meta: {title: "修改密码"},
		},{
			path: '/wish',
			name: "志愿填报",
			component: wish,
			meta: {title: "志愿填报"},
		},{
			path: '/wish_list',
			name: "院校历年各专业录取信息",
			component: wish_list,
			meta: {title: "院校历年各专业录取信息"},
		},{
			path: '/help',
			name: "帮助中心",
			component: help,
			meta: {title: "帮助中心"},
		},{
			path: '/help_list',
			name: "帮助中心列表",
			component: help_list,
			meta: {title: "帮助中心列表"},
		},{
			path: '/help_details',
			name: "帮助详情",
			component: help_details,
			meta: {title: "帮助详情"},
		},{
			path: '/add_class',
			name: "加入班级",
			component: add_class,
			meta: {title: "加入班级"},
		},{
			path: '/my_task',
			name: "我的作业",
			component: my_task,
			meta: {title: "我的作业"},
		},{
			path: '/my_task_list',
			name: "作业列表",
			component: my_task_list,
			meta: {title: "作业列表"},
		},{
			path: '/my_class',
			name: "我的班级",
			component: my_class,
			meta: {title: "我的班级"},
		},{
			path: '/my_info',
			name: "个人信息",
			component: my_info,
			meta: {title: "个人信息"},
		},{
			path: '/task_school_paper',
			name: "校本作业",
			component: task_school_paper,
			meta: {title: "校本作业"},
		},{
			path: '/task_report',
			name: "试卷作业报告",
			component: task_report,
			meta: {title: "试卷作业报告"},
		},{
			path: '/task_proof',
			name: "校本试卷核对",
			component: task_proof,
			meta: {title: "校本试卷核对"},
		},{
			path: '/task_school_report',
			name: "校本试卷报告",
			component: task_school_report,
			meta: {title: "校本试卷报告"},
		},{
			path: '/class_manage',
			name: "班级管理",
			component: class_manage,
			meta: {title: "班级管理"},
		},{
			path: '/class_details',
			name: "班级详情",
			component: class_details,
			meta: {title: "班级详情"},
		},{
			path: '/class_join',
			name: "加入行政班",
			component: class_join,
			meta: {title: "加入行政班"},
		},{
			path: '/task',
			name: "布置作业",
			component: task,
			meta: {title: "布置作业"},
		},{
			path: '/task_video',
			name: "视频作业",
			component: task_video,
			meta: {title: "视频作业"},
		},{
			path: '/task_paper',
			name: "试卷作业",
			component: task_paper,
			meta: {title: "试卷作业"},
		},{
			path: '/task_topic',
			name: "习题作业",
			component: task_topic,
			meta: {title: "习题作业"},
		},{
			path: '/school_paper',
			name: "校本试卷",
			component: school_paper,
			meta: {title: "校本试卷"},
		},{
			path: '/school_video',
			name: "校本视频",
			component: school_video,
			meta: {title: "校本视频"},
		},{
			path: '/basket',
			name: "作业篮",
			component: basket,
			meta: {title: "作业篮"},
		},{
			path: '/basket_success',
			name: "布置成功",
			component: basket_success,
			meta: {title: "布置成功"},
		},{
			path: '/paper_details',
			name: "试卷预览",
			component: paper_details,
			meta: {title: "试卷预览"},
		},{
			path: '/record',
			name: "作业记录",
			component: record,
			meta: {title: "作业记录"},
		},{
			path: '/organize',
			name: "我的组卷",
			component: organize,
			meta: {title: "我的组卷"},
		},{
			path: '/organize_details',
			name: "组卷预览",
			component: organize_details,
			meta: {title: "组卷预览"},
		},{
			path: '/paper_my',
			name: "学校资源库·试卷库",
			component: paper_my,
			meta: {title: "学校资源库·试卷库"},
		},{
			path: '/paper_found',
			name: "创建试卷",
			component: paper_found,
			meta: {title: "创建试卷"},
		},{
			path: '/paper_edit',
			name: "校本试卷详情",
			component: paper_edit,
			meta: {title: "校本试卷详情"},
		},{
			path: '/video_my',
			name: "学校资源库·视频库",
			component: video_my,
			meta: {title: "学校资源库·视频库"},
		},{
			path: '/video_upload',
			name: "视频上传",
			component: video_upload,
			meta: {title: "视频上传"},
		},{
			path: '/video_play',
			name: "视频播放",
			component: video_play,
			meta: {title: "视频播放"},
		},{
			path: '/student_report',
			name: "学生使用报告",
			component: student_report,
			meta: {title: "学生使用报告"},
		},{
			path: '/kno_report',
			name: "知识点分析",
			component: kno_report,
			meta: {title: "知识点分析"},
		},{
			path: '/notice',
			name: "发布公告",
			component: notice,
			meta: {title: "发布公告"},
		},{
			path: '/record_details',
			name: "作业详情",
			component: record_details,
			meta: {title: "作业详情"},
		},{
			path: '/courseware',
			name: "课件",
			component: courseware,
			meta: {title: "课件"},
		},{
			path: '/courseware_upload',
			name: "课件上传",
			component: courseware_upload,
			meta: {title: "课件上传"},
		}
	]
});
export default router
